
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import EditorPageLayout from "../../common/editor/EditorPageLayout";
import Form from "./form/Form";

export default function WorkshopEdit() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);
	const params = useParams();
	const workshopId = params.workshopId;
	const [workshop, setWorkshop] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	useEffect(() => {
		setIsLoading(true);
		api.workshopFetchEdit({
			token: LoginHelper.getToken(),
			workshop_id: workshopId,
		}).then((result) => {
			setWorkshop(result);
			setIsLoading(false);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}, [workshopId]);

	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'کارگاه‌ها', href: '/workshop_list/' },
		{ label: 'ویرایش کارگاه' },
	];

	return (
		<EditorPageLayout
			isDesktop={isDesktop}
			pageTitle="ویرایش کارگاه"
			metaDescription="ویرایش کارگاه در همراهتیم"
			breadcrumbLinks={linkDataList}
			isLoading={isLoading}
			loadError={errorMessage && !workshop ? errorMessage : ""}
		>
			{workshop && <Form workshop={workshop} isDesktop={isDesktop} />}
		</EditorPageLayout>
	);
}
